import React, { Component } from 'react';

import BarChart from '../../components/BarChart';
import ResultTable from '../../components/ResultTable';

import '../../components/ToolTip.css';

import format from '../../utility/format';

export default class LeadTrustResult extends Component {

    render() {
        var params = this.props.params;
        var result = this.props.result;
        var clientDefaults = this.props.clientDefaults;
        var organization = clientDefaults.organizationName || 'us';
        var joint = (params.type === 'double') ? ' joint ' : ' ' ;
        var payoutSection;
        if (params.trustType === 'fixed') {
            payoutSection = {
                label: `Trust's Total Payment to You`,
                number: format.dollars(result.totalPayment),
                notes: (<div>
                    <div>{ format.dollars(result.firstYearPayment) } ({ format.percent(params.payoutRate) } of { format.dollarsShort(params.giftAmount) }) per year for { (params.type === 'fixed') ? params.years + ' years' : ' the rest of your expected lifespan' }</div>
                    <div>Payments are taxed in four tiers based on the type of income the trust earns: ordinary income, capital gains, tax-free income and return of principal. See your trustee for the exact taxation of your payments each year.</div>
                </div>),
            };
        } else {
            payoutSection = {
                label: `Trust's First-Year Payment to You`,
                number: format.dollars(result.firstYearPayment),
                notes: (<div>
                    <div>Payments will vary after the first year based on the performance of trust assets.</div>
                    <div>Payments are taxed in four tiers based on the type of income the trust earns: ordinary income, capital gains, tax-free income and return of principal. See your trustee for the exact taxation of your payments each year.</div>
                </div>),
            };
        }

        var data = [
            {
                label: `Estimated Amount to ${organization}`,
                number: format.dollars(result.charitableGiftValue),
                notes: `Amount remaining after ${ params.type === 'fixed' ? result.years + ' years' : 'your' + joint + result.years.toFixed(0) + '-year life expectancy' }, assuming 6% annual growth.`,
            },
            payoutSection,
            {
                label: 'Potential Income Tax Charitable Deduction',
                number: format.dollars(result.charitableTaxDeduction),
                notes: (<div>
                    Based on a { format.percent(result.CMFRrate) } <span className="tooltip">charitable midterm federal rate<span className="tooltiptext">the monthly interest rate used to calculate your gift&rsquo;s charitable deduction</span></span>.
                    <br /><br />
                    Deductible up to 60% of your adjusted gross income for cash gifts.
                    <br /><br />
                    Deductible up to 30% of your adjusted gross income for appreciated property owned for more than one year.
                    <br /><br />
                    Unused amount may be carried over for up to five additional years.
                </div>),
            },
        ];

        return (<div>
            <div className="viz">
                <BarChart
                    title="Bar chart showing gift breakdown"
                    desc="Bar chart showing how much of your gift goes to loved ones and how much goes to us"
                    values={ [
                        {amount: result.charitableGiftValue , label: 'Estimated amount to organization'},
                        {amount: result.totalPayment , label: 'Estimated amount to loved ones'},
                    ] } />
            </div>

            <ResultTable data={data} />
        </div>);
    }

}
